import gsap from 'gsap';
import { IsTouchDevice } from '../utils';
let currentOpenId = '',
  isReadyCloseObj = {};
export const MegaMenu = {
  toggles: null,
  closes: null,
  init() {
    this.toggles = document.querySelectorAll('.js-mega-toggle');
    this.closes = document.querySelectorAll('.js-mega-close');
    if (this.toggles.length) {
      this.toggles.forEach((toggle) => {
        if (IsTouchDevice()) {
          toggle.addEventListener('click', () => {
            this.toggle(toggle.getAttribute('aria-controls'));
          });
        } else {
          const id = toggle.getAttribute('aria-controls');
          isReadyCloseObj[id] = false;
          const megaMenu = document.getElementById(id);
          toggle.addEventListener('mouseenter', () => {
            isReadyCloseObj[id] = false;
            this.open(id);
          });
          toggle.addEventListener('mouseleave', () => {
            isReadyCloseObj[id] = true;
            setTimeout(() => {
              if (isReadyCloseObj[id]) {
                this.close(id);
              }
            }, 200);
          });
          megaMenu.addEventListener('mouseenter', () => {
            isReadyCloseObj[id] = false;
            this.open(id);
          });
          megaMenu.addEventListener('mouseleave', () => {
            isReadyCloseObj[id] = true;
            setTimeout(() => {
              if (isReadyCloseObj[id]) {
                this.close(id);
              }
            }, 200);
          });
        }
      });
    }

    if (this.closes.length) {
      this.closes.forEach((btn) => {
        btn.addEventListener('click', () => {
          const megamenu = btn.closest('.c-megamenu');
          this.close(megamenu.id);
        });
      });
    }

    document.body.addEventListener('click', (event) => {
      const btn = event.target.closest('.js-mega-open');
      if (btn) {
        if( currentOpenId != ''){
          this.close(currentOpenId);
        }
        this.open(btn.getAttribute('aria-controls'));
      }
    });
  },
  toggle(id) {
    if (currentOpenId != '') {
      this.close(currentOpenId);
      if (currentOpenId == id) {
        currentOpenId = '';
      } else {
        currentOpenId = id;
        this.open(id);
      }
    } else {
      currentOpenId = id;
      this.open(id);
    }
  },
  open(id) {
    const toggles = document.querySelectorAll(`.js-mega-toggle[aria-controls="${id}"]`);
    toggles.forEach((toggle) => {
      toggle.classList.add('is-active');
    });
    const megaMenu = document.getElementById(id);
    currentOpenId = id;
    gsap.to(megaMenu, {
      duration: 0.3,
      autoAlpha: 1,
    });
  },
  close(id) {
    const toggles = document.querySelectorAll(`.js-mega-toggle[aria-controls="${id}"]`);
    toggles.forEach((toggle) => {
      toggle.classList.remove('is-active');
    });
    currentOpenId = '';
    const megaMenu = document.getElementById(id);
    gsap.to(megaMenu, {
      duration: 0.1,
      autoAlpha: 0,
    });
  },
};
